<template>
  <!-- 产品服务-车链云 -->
  <div class="box cly">
    <div v-if="!isM" class="cly0 bgimg"></div>
    <div v-if="isM" class="clym0"></div>

    <div class="cly1">
      <div class="min_box">
        <ul class="c1_box">
          <li v-for="(item, index) in arr" :key="item.id">
            <img
              :src="picUrl + 'cly' + (index + 1) + '.png'"
              :alt="item.name"
            />
            <div>
              <p>{{ item.name }}</p>
              <span>{{ item.dec }}</span>
            </div>
          </li>
        </ul>
        <img class="clyphobe" :src="picUrl + 'clyphobe.png'" alt="车链云" />
      </div>
    </div>

    <div class="cly2">
      <div class="min_box">
        <div class="m_box_top">
          <h4 class="blue_h4">四大汽车金融服务</h4>
          <ul class="c2_box">
            <li v-for="(item, index) in arr2" :key="item.id">
              <img :src="picUrl + 'clyo' + (index + 1) + '.jpg'" />
              <div>
                <p>{{ item.tit }}</p>
                <span>{{ item.dec }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="m_box_botm">
          <p class="cly_tit">办理流程无纸化操作，全线上放款</p>
          <ul class="cl_ul">
            <li v-for="(item, index) in arr1" :key="item.id">
              <img :src="picUrl + 'clyi' + (index + 1) + '.png'" :alt="item" />
              <p>{{ item }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="!isM" class="cly3 bgimg"></div>
    <div v-if="isM" class="cly3m"></div>

    <div class="cly4">
      <div class="min_box">
        <h4 class="blue_h4">车链云SAAS管理</h4>
        <p class="gary_dec">开放式 科技化</p>
        <ul class="cly4_ul">
          <li v-for="(item, index) in arr3" :key="item.id">
            <img
              :src="picUrl + 'clys' + (index + 1) + '.png'"
              :alt="item.tit"
            />
            <div>
              <p>{{ item.tit }}</p>
              <span>{{ item.dec }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cly",
  data() {
    return {
      picUrl: this.$root.picUrl,
      arr: [
        {
          name: "成本低",
          dec: "银行资金直连，利息低至0.04%",
        },
        {
          name: "额度高",
          dec: "单次用款金额最高可达800万",
        },
        {
          name: "放款快",
          dec: "全线上流程，最快2小时放款",
        },
        {
          name: "周期活",
          dec: "随借随还，借款期最长可达90天 ",
        },
      ],
      arr1: [
        "①企业授信认证",
        "②在线提交申请",
        "③上传相关资料",
        "④在线签署合同",
        "⑤立即放款",
      ],
      arr2: [
        {
          tit: "车商采购垫资",
          dec: "快速垫款，不再等贷",
        },
        {
          tit: "车商展车融资",
          dec: "超长期限，高额借贷",
        },
        {
          tit: "车商库存融资",
          dec: "超低利率，借贷省心",
        },
        {
          tit: "4S店提车融资",
          dec: "融资便捷，灵活提车",
        },
      ],
      arr3: [
        {
          tit: "车商管理",
          dec: "掌控车商行为",
        },
        {
          tit: "贷款管理",
          dec: "资金流向管理",
        },
        {
          tit: "风险管理",
          dec: "风险控制预警",
        },
        {
          tit: "产品管理",
          dec: "金融产品控制",
        },
      ],
      isM: false,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Proservices/cly.vue